import { gql, useQuery } from '@apollo/client';
import {
  GetAttributesQuery,
  GetAttributesQueryVariables,
} from '../../__generated__/queries-web';

export const GET_ATTRIBUTES = gql`
  query GetAttributes(
    $first: UnsignedInt!
    $where: AttributeFilterInput
    $skip: UnsignedInt
    $orderBy: [AttributeOrderingInput!]
  ) {
    attributes(first: $first, where: $where, skip: $skip, orderBy: $orderBy) {
      id
      title
      createdAt
      updatedAt
      brandKey
      slug
      authors(first: 100) {
        author {
          id
          name
        }
      }
    }
  }
`;

export const useAttributes = (variables: GetAttributesQueryVariables) => {
  return useQuery<GetAttributesQuery, GetAttributesQueryVariables>(
    GET_ATTRIBUTES,
    {
      variables,
      fetchPolicy: 'network-only',
    },
  );
};
